import { render, staticRenderFns } from "./CardCategory.vue?vue&type=template&id=54ef83f4&"
import script from "./CardCategory.vue?vue&type=script&lang=js&"
export * from "./CardCategory.vue?vue&type=script&lang=js&"
import style0 from "./CardCategory.vue?vue&type=style&index=0&id=54ef83f4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports